import styled from 'styled-components';

type RadioProps = {
  isSelected: boolean;
}

export const Radio = styled.button<RadioProps>`
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  border: 1px solid var(--color-separator-light);
  cursor: pointer;

  ${(props) => props.isSelected && `
    &:after {
      content: "";
      position: absolute;
      width: 0; 
      height: 0; 
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 4px solid var(--color-separator-default);
      top: -9px;
      left: 16px;
    }
    &:before {
      content: "";
      position: absolute;
      display: block;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      top: -4px;
      left: -4px;
      border: 1px solid var(--color-separator-default);
    }
  `}
`;
